module.exports = __webpack_public_path__ + "static/media/logo-google-playstore.5cc64b41.svg";